<template>
  <div class="cb">
    <!-- 我的购物车 -->
    <div class="user-info6 w-100" style="margin-bottom: 1.2rem">
      <a class="active">全部商品</a>
      <a @click="tabChange">价格变动</a>
      <a @click="tabChange">库存紧张</a>
    </div>
    <div
      class="no-content w-100"
      style="display: flex; justify-content: center"
      v-if="list.length == 0"
    >
      <img src="/static/img/no_data5.png" />
    </div>
    <div style="overflow-y: scroll; max-height: 580px; width: 100%" v-else>
      <table class="table table-hover w-100">
        <tr>
          <th width=""><label class="checkbox-inline">商品信息</label></th>
          <!-- <th>价格(含税)</th> -->
          <th>数量</th>
          <!-- <th>小计(含税)</th> -->
          <th>加购时间</th>
          <th width="80">操作</th>
        </tr>
        <template v-for="(item, index) in list">
          <tr>
            <td>
              <div class="sp-info">
                <input
                  type="checkbox"
                  :checked="item.checked"
                  class="checkbox-style sonCheckbox"
                  name=""
                  id=""
                  :value="index"
                  @click="checkedOne(item)"
                />
                <div @click="clickDetails(item)" class="between-center" style="justify-content: flex-start">
                  <img :src="item.goodsCoverUrl" />
                  <div>
                    <span>{{ item.goodsName }}</span>
                    <p>型号：{{ item.specName }}</p>
                  </div>
                </div>
              </div>
            </td>
            <!-- <td>￥{{ item.price }}</td> -->
            <td>
              <!-- {{ item.quantity }} -->

              <el-input-number
                @change="quantityChange($event, item)"
                :min="1"
                :max="item.goods.totalInventory"
                v-model="item.quantity"
                :key="item.timer"
              ></el-input-number>
            </td>
            <!-- <td>￥{{ item.totalAmt }}</td> -->
            <td>{{ item.whenCreated }}</td>
            <td>
              <div class="sp-btn">
                <a href="javascript:;" @click="deleteItem(item, index)">删除</a>
                <!-- <a href="">移入收藏夹</a> -->
              </div>
            </td>
          </tr>
        </template>
      </table>
    </div>

    <div class="user-info4 w-100 between-center" v-if="list.length != 0">
      <div class="f-l between-center">
        <label class="checkbox-inline"
          ><input
            type="checkbox"
            class="checkbox-style allCheckbox"
            name=""
            id=""
            value=""
            :checked="allCheck"
            @click="checkedAll"
          />&nbsp;</label
        >
        全选
        <span @click="deleteCheck">删除所选</span>
        <span @click="collectChange">移入收藏夹</span>
        <span @click="clearCart">清空购物车</span>
      </div>
      <div class="f-r between-center">
        <span style="position: relative; top: 4px"
          >已选择{{ amountGoodsT }}件商品</span
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<!-- <span>
          总价<i>￥{{ allPrice }}</i></span> -->
        <a
          href="javascript:;"
          style="background-color: rgb(0, 64, 150)"
          @click="confirmOrder"
          >生成意向单</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { goodsCart } from "@/common/http.js";
import { message } from "@/common/common.js";
import { goodsCollection, getCategories } from "../../common/http";
export default {
  data() {
    return {
      tableView: [],
      list: [],
      goodsId: [],
      allCheck: false,
      allPrice: 0,
      amountGoods: 0,
      categorys: []
    };
  },
  computed: {
    amountGoodsT() {
      return this.list.reduce((pre, cur, index) => {
        if (cur.checked) {
          return pre + cur.quantity * 1
        }
        return pre
      }, 0)
    }
  },
  mounted() {
    this.$emit("change_bread", 3);
    this.getCart();
    this.initCategory();
  },
  methods: {
    tabChange() {
      message({
        message: "功能暂未开放",
        type: "warning"
      });
    },
    initCategory() {
      getCategories({
        // homeCategoryId: 15,
        // isChildren: 1,
        type: 1
      }).then(res => {
        if (res.result) {
          this.categorys = res.data;
        }
      });
    },
    getCart() {
      let that = this;
      goodsCart({}, "get").then(res => {
        if (res.result) {
          if (res.data.length != 0) {
            that.list = res.data.map(item => {
              item.checked = false;
              item.timer = 0
              return item;
            });
            that.total = that.list.length; // 算总数
          } else {
            that.list = []
          }
        }
      });
    },
    compareCart() {
      this.tableView.map(item => {
        this.list.map(it => {
          if (it.id == item.id) {
            item.checked = it.checked;
          }
        });
      });
    },
    // 改变数量
    quantityChange(e, item) {
      if (!e) {
        const index = this.list.findIndex((it) => it.id === item.id)
        this.list[index].quantity = 1
        this.list[index].timer = new Date().getTime()
        return
      }
      let that = this;
      goodsCart({ uid: item.uid, quantity: e }, "put").then(res => {
        if (res.result) {
          that.$store.commit("refreshCart", true);
          // that.getCart();
          // if (that.allCheck) {
          //   that.allCheck = false;
          //   that.allPrice = 0;
          //   that.amountGoods = 0;
          // }
          message({
            message: "修改成功",
            type: "success"
          });
        }
      });
    },
    // 全选
    checkedAll() {
      let that = this;
      that.goodsId = [];
      that.allPrice = 0;
      that.amountGoods = 0;
      if (!that.allCheck) {
        that.list.map(item => {
          item.checked = true;
          that.goodsId.push(item);
          that.amountGoods += item.quantity;
          that.allPrice += item.totalAmt;
        });
      } else {
        that.list.map(item => {
          item.checked = false;
        });
        that.allPrice = 0;
      }
      that.allCheck = !that.allCheck;
    },
    // 单选
    checkedOne(item) {
      let that = this;
      that.$set(item, "checked", !item.checked);
      if (item.checked) {
        that.goodsId.push(item);
        that.allPrice += item.totalAmt;
        that.amountGoods += item.quantity;
        if (that.goodsId.length == that.list.length) {
          that.allCheck = true;
        }
      } else {
        that.goodsId.map((v, index) => {
          if (v.id == item.id) {
            that.goodsId.splice(index, 1);
            that.allPrice -= v.totalAmt;
            that.amountGoods -= item.quantity;
          }
        });
        if (that.goodsId.length != this.list.length) {
          that.allCheck = false;
        }
      }
    },
    // 删除单个
    deleteItem(item) {
      this.$confirm("确定从购物车移除该商品吗？?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success"
      })
        .then(() => {
          const uids = [];
          // this.allPrice -= v.totalAmt;
          this.amountGoods -= item.quantity;
          uids.push(item.uid);
          goodsCart({ uids }, "delete").then(res => {
            if (res.result) {
              this.$store.commit("refreshCart", true);
              this.getCart();
              message({
                message: "删除成功",
                type: "success"
              });
            }
          });
        })
        .catch(() => {});
    },
    // 删除所选
    deleteCheck() {
      let that = this;
      if (that.amountGoodsT == 0) {
        message({
          message: "请选择需要删除的商品",
          type: "warning"
        });
        return;
      }
      that
        .$confirm(
          `确定删除${that.amountGoodsT}件商品吗？`,
          "是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
        .then(() => {
          // for (let i = that.goodsId.length - 1; i >= 0; i--) {
          //   const item = that.goodsId[i];
          //   that.list.map((it, index) => {
          //     if (it.id == item.id) {
          //       that.list.splice(index, 1);
          //     }
          //   });
          // }
          // const uids = that.goodsId.map(i => i.uid);
          const uids = that.list.filter((it) => {
            if (it.checked) return it
          }).map((it) => it.uid)
          that.deleteCart(uids);
          that.goodsId = [];
          that.allPrice = 0;
          that.amountGoods = 0;
        })
        .catch(() => {});
    },
    collectChange() {
      let that = this;
      if (that.amountGoodsT == 0) {
        message({
          message: "请选择需要收藏商品",
          type: "warning"
        });
        return;
      }
      const uids = that.goodsId.map(i => i.goods.id);
      goodsCollection({
        goodsIds: uids,
        type: 1
      }).then(res => {
        if (res.result) {
          message({
            message: "加入收藏成功",
            type: "success"
          });
          that.goodsId = [];
        }
      });
    },
    clickDetails(item) {
      let params = {};
      params.uid = item.goods.uid;
      params.childrenName = item.goods.category.name;
      params.productId = item.goods.category.id;

      // 递归查找所有父级节点
      const findParents = (data, targetId, path = []) => {
        for (const item of data) {
          if (item.id === targetId) {
            return [...path, item];
          }
          if (item.children) {
            const result = findParents(item.children, targetId, [
              ...path,
              item
            ]);
            if (result) {
              return result;
            }
          }
        }
        return null;
      };

      // 查找匹配的节点及其所有父级
      const parents = findParents(this.categorys, params.productId);
      this.$store.commit("SET_CATEGORYDATA", parents);
      const routerJump = this.$router.resolve({
        name: "productTypeScreen",
        path: "/productTypeScreen",
        query: params
      });

      window.open(routerJump.href, "_blank");
    },
    clearCart() {
      this.$confirm(`确定清空购物车吗？`, "是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const uids = this.list.map(i => i.uid);
          this.deleteCart(uids);
          this.list = [];
        })
        .catch(() => {});
    },
    async deleteCart(uids) {
      await goodsCart({ uids }, "delete").then(res => {
        if (res.result) {
          this.$store.commit("refreshCart", true);
          this.getCart();
          message({
            message: "删除成功",
            type: "success"
          });
        }
      });
    },
    // 去结算
    confirmOrder() {
      if (this.goodsId.length == 0) {
        message({
          message: "请选择需要结算的商品",
          type: "warning"
        });
        return;
      }
      let str = JSON.stringify(this.goodsId);
      this.$router.push({
        path: "/confirmOrder",
        query: {
          arr: str
        }
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/userCenter/meCart.vue